import { render } from "./PrintHeader8cm.vue?vue&type=template&id=9849f98a&scoped=true"
import script from "./PrintHeader8cm.vue?vue&type=script&lang=js"
export * from "./PrintHeader8cm.vue?vue&type=script&lang=js"

import "./PrintHeader8cm.vue?vue&type=style&index=0&id=9849f98a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9849f98a"]])

export default __exports__